import { useFetch } from 'use-http'
import { getAbsoluteServerUrl } from '../config/config'

type CAText = { id: string; body: string; created_at: Date; }

export function useGetClimateAction() {
  return useFetch<CAText[]>(getAbsoluteServerUrl('/climate-action'), { responseType: 'json' }, [])
}
